

<div style="display:block;">
  <div data-testid="add-action" tabindex="0" [attr.aria-label]="'toggle action button'" (keyup.space)="onToggle()" (keyup.enter)="onToggle()" (click)="onToggle()" [ngClass]="{'reminder': this.isReminder, 'added': this.added,'add-action' : true, 'with-title':withTitle}"><div class="icon"></div><div class="action-text">@if (withTitle) {
  <span [innerHTML]="this.actionObject.title"></span>
}</div></div>
</div>
